import React from 'react';
import dateTimeFormatService from 'services/formatters/datetime/dateTimeFormat.service';

export default function DateFormatter({ date }: { date: Date }) {
	return <>{dateTimeFormatService.format(date, { includeHourAndMinute: false })}</>;
}
